import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Avatar,
  Box,
} from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { AccordionArrowPurple, AccordionArrowPurpleClose } from 'Images';
import { FC, useEffect, useState } from 'react';

interface IAccordionUserDetails {
  title: string;
  isOpen?: boolean;
}

export const AccordionUserDetails: FC<IAccordionUserDetails> = (props) => {
  const isDesktop = useIsDesktop();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (props.isOpen) setIsExpanded(true);
  }, [props.isOpen]);

  return (
    <Accordion
      disableGutters
      expanded={isExpanded}
      elevation={0}
      sx={{
        boxShadow: '-2px -2px 12px 0px rgba(8, 30, 84, 0.04)',
        border: '1px solid',
        borderColor: 'primary.shade_100',
        borderRadius: '16px',
        overflow: 'hidden',

        '&::before': { display: 'none' },
        '&.Mui-disabled': { backgroundColor: 'white' },
      }}
    >
      <AccordionSummary
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{
          padding: isDesktop ? '0 24px' : '0 16px',
          position: 'relative',
          '.MuiAccordionSummary-content': { margin: '24px 0' },
        }}
        expandIcon={
          <>
            {!isExpanded && (
              <Avatar
                alt={''}
                src={AccordionArrowPurple}
                sx={{
                  width: '40px',
                  height: '40px',
                }}
              />
            )}
            {isExpanded && (
              <Avatar
                alt={''}
                src={AccordionArrowPurpleClose}
                sx={{
                  width: '35px',
                  height: '35px',
                  rotate: '180deg',
                }}
              />
            )}
          </>
        }
      >
        <Typography variant={'body1'} component='h2'>
          {props.title}
        </Typography>
        {isDesktop && (
          <Box
            width={'153px'}
            height={'153px'}
            borderRadius={'50%'}
            position={'absolute'}
            top={'-60px'}
            right={'-6%'}
            bgcolor={'purple2.shade_100'}
            sx={{
              opacity: '.7',
            }}
          ></Box>
        )}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: isDesktop ? ' 0 24px 32px 16px' : '0 16px 24px 16px',
        }}
      >
        {props.children}
      </AccordionDetails>
    </Accordion>
  );
};
